import { SagaIterator } from 'redux-saga';
import { call, put, take, takeEvery } from 'redux-saga/effects';
import {
  GlobalActions,
  GlobalPut,
  ModalCloseReason,
  ModalType,
} from '@ps20-frontend/shop-integration-redux';
import { App, Vorvertrag } from '@ps20-frontend/frontend-models';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { DashboardAction, DashboardActions } from '../dashboard.actions';

export function* vorvertragHinweisModalWithOptionenRequests(): SagaIterator {
  yield takeEvery(
    DashboardActions.REQUEST_VORVERTRAG_HINWEISMODAL_WITH_OPTIONEN,
    safeSaga(requestModal, App.SHOP_DASHBOARD),
  );
}

export function* requestModal(
  action: DashboardAction<{
    type: ModalType;
    vertrag: Vorvertrag;
    hinweis: string;
  }>,
): SagaIterator {
  const payload = action.payload;
  yield call(
    GlobalPut.getInstance().put,
    new GlobalActions().requestModal(payload.type, { body: payload.hinweis }),
  );
  const closeModalAction = yield take(GlobalActions.CLOSE_MODAL);

  if (closeModalAction.payload === ModalCloseReason.PRIMARY) {
    yield put(new DashboardActions().vorvertragUmstellen(payload.vertrag));
  }
}
